/**
 * @flow
 * @relayHash 68f3fdc5e1b56755479d54dc9885c146
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ItemCategorySortField = "CREATED_AT" | "NAME" | "UPDATED_AT";
export type SortDirection = "ASC" | "DESC";
export type ItemCategorySort = {|
  field: ItemCategorySortField,
  direction: SortDirection,
|};
export type SelectItemCategoryFieldQueryVariables = {|
  sortBy?: ?ItemCategorySort,
  search?: ?string,
|};
export type SelectItemCategoryFieldQueryResponse = {|
  +itemCategories: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +name: string,
      |}
    |}>
  |}
|};
export type SelectItemCategoryFieldQuery = {|
  variables: SelectItemCategoryFieldQueryVariables,
  response: SelectItemCategoryFieldQueryResponse,
|};
*/


/*
query SelectItemCategoryFieldQuery(
  $sortBy: ItemCategorySort
  $search: String
) {
  itemCategories(first: 300, sortBy: $sortBy, search: $search) {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "ItemCategorySort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "itemCategories",
    "storageKey": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 300
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      },
      {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
      }
    ],
    "concreteType": "ItemCategoryConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemCategoryEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemCategory",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SelectItemCategoryFieldQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SelectItemCategoryFieldQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "SelectItemCategoryFieldQuery",
    "id": null,
    "text": "query SelectItemCategoryFieldQuery(\n  $sortBy: ItemCategorySort\n  $search: String\n) {\n  itemCategories(first: 300, sortBy: $sortBy, search: $search) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '91263c60dab512daadbeaa1aedb314de';
module.exports = node;
